import FlashLib from 'flashlib_onlyplay';
import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import SoundManager from 'Engine/soundManager/SoundManager';
import { makeHitArea } from 'Engine/utils/makeHitArea';

export default class PaytableControls extends FlashLib.MovieClip {
  constructor(data, displayData) {
    super(data, displayData);

    this.init();
    this.addActions();

    this.eventMode = 'static';
    this.range = null;
    this.currentPage = 1;
  }

  init() {
    this.btnLeft = this.getChildByName('btnLeft');
    this.btnRight = this.getChildByName('btnRight');
    this.btnBack = this.getChildByName('btnBack');
    makeHitArea(this.btnLeft);
    makeHitArea(this.btnRight);
    makeHitArea(this.btnBack);
    this.btnBack.enabled = true;
    this.btnLeft.enabled = true;
    this.btnRight.enabled = true;
  }

  addActions() {
    this.btnLeft.on('pointertap', this.onLeftClick, this);
    this.btnRight.on('pointertap', this.onRightClick, this);
    this.btnBack.on('pointertap', this.onBackClick, this);
  }

  tryCycle() {
    if (this.currentPage < this.range[0]) {
      this.currentPage = this.range[this.range.length - 1];
    } else if (this.currentPage > this.range[this.range.length - 1]) {
      this.currentPage = this.range[0];
    }
  }

  onBackClick() {
    GlobalDispatcher.dispatch('paytable:backClick');
    this.reset();
  }

  onLeftClick() {
    this.currentPage--;
    this.tryCycle();
    GlobalDispatcher.dispatch('paytable:changePage', this.currentPage);
  }

  onRightClick() {
    this.currentPage++;
    this.tryCycle();
    GlobalDispatcher.dispatch('paytable:changePage', this.currentPage);
  }

  setRange(array) {
    this.range = array;
  }

  reset() {
    this.currentPage = 1;
  }
}
